module.exports = {"id":"178372","name":"Branislav Ivanović","rating":"82","photo":"./data/images/photos/4/178372.png","club":{"name":"Zénith","logo":"./data/images/clubs/Zenith.png"},"positions":["DC","DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BranislavIvanovic0.json
// module id = 642
// module chunks = 0